import { render } from "./ImportRole.vue?vue&type=template&id=b66bac7a&scoped=true"
import script from "./ImportRole.vue?vue&type=script&lang=js"
export * from "./ImportRole.vue?vue&type=script&lang=js"

import "./ImportRole.vue?vue&type=style&index=0&id=b66bac7a&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66bac7a"]])

export default __exports__